<template>
  <div class="vl-form-col--12-12">
    <label :for="label" class="capitalize vl-form__label">{{ label }}</label>

    <slot />
    
  </div>
</template>

<script>
export default {
  name: 'FormField',

  props: ['label'],
};
</script>

<style module>
.container {
  align-items: center;
  display: flex;
  flex-grow: 1;
  margin-bottom: 1rem;
}

.container input {
  flex-grow: 1;
  margin-left: 1rem;
}
</style>
